export default __webpack_public_path__ + "assets/images/turtle-red-7f2d3abfbd210720bf3678dc07d848cb.svg";